import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Tooltip,
  Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { InformationCircleOutlined as InformationCircleOutlinedIcon } from '../../../icons/information-circle-outlined';
import { Chart } from '../../chart';
import { useEffect, useState } from 'react';

export const CallCenterAnalytics = (props) => {
  const { status = [], user } = props;
  const theme = useTheme();
  const [ doShow, setDoShow ] = useState(false);

  useEffect(() => {
    // Recorrer el array de status y ver si hay alguno que no sea 0
    const statusFiltered = status.filter((item) => item.count > 0);
    if (statusFiltered.length > 0) {
      setDoShow(true);
    } else {
      setDoShow(false);
    }
  }, [ status ]);

  // Construye el objeto de datos para el gráfico
  const data = {
    series: []
  };

  const colores = [
    "#FF5733", // Rojo
    "#3498DB", // Azul
    "#27AE60", // Verde
    "#F1C40F", // Amarillo
    "#9B59B6", // Morado
    "#E74C3C", // Rojo claro
    "#2980B9", // Azul claro
    "#2ECC71", // Verde claro
    "#F39C12", // Naranja
    "#8E44AD"  // Morado oscuro
  ];

  const estatus = [
    {
      value: 'pending',
      label: 'Pendiente'
    },
    {
      value: 'accepted',
      label: 'Aceptado'
    },
    {
      value: 'notAnswered',
      label: 'No contesto/Desvio'
    },
    {
      value: 'notExist',
      label: 'No existe'
    },
    {
      value: 'done',
      label: 'Realizado'
    },
    {
      value: 'unattainable',
      label: 'Inalcanzable'
    }

  ]

  status.forEach((status, index) => {
    const label = estatus.find((item) => item.value === status.status).label;
    data.series.push({
      color: colores[index],
      data: status.count,
      label: label
    });

    // Limpiar los que tenga 0
    
    data.series = data.series.filter((item) => item.data > 0);
  });


  const chartOptions = {
    chart: {
      background: 'transparent',
      stacked: false,
      toolbar: {
        show: false
      }
    },
    colors: data.series.map((item) => item.color),
    dataLabels: {
      enabled: false
    },
    fill: {
      opacity: 1
    },
    labels: data.series.map((item) => item.label),
    legend: {
      show: false
    },
    stroke: {
      width: 0
    },
    theme: {
      mode: theme.palette.mode
    }
  };

  const chartSeries = data.series.map((item) => item.data);

  return (
    <>
      {
        doShow && (
          <Card>
            <CardHeader
              title={user === 'callcenteradmin' ? 'Estatus de las llamadas en los ultimos 30 días' : 'Estatus de tus llamadas'}
              action={(
                <Tooltip title="De las llamadas que has realizado, aquí puedes ver el estatus de las mismas en los ultimos 30 días">
                  <InformationCircleOutlinedIcon sx={{ color: 'action.active' }} />
                </Tooltip>
              )}
            />
            <Divider />
            <CardContent>
              <Chart
                height={200}
                options={chartOptions}
                series={chartSeries}
                type="donut"
              />
              <Grid container>
                {data.series.map((item) => (
                  <Grid
                    item
                    key={item.label}
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      p: 1
                    }}
                    xs={6}
                  >
                    <Box
                      sx={{
                        border: 3,
                        borderColor: item.color,
                        borderRadius: '50%',
                        height: 16,
                        mr: 1,
                        width: 16
                      }}
                    />
                    <Typography variant="subtitle2">
                      {item.data} - {item.label}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        ) || (
          <Card>
            <CardContent
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                p: 4
              }}
            >
              <InformationCircleOutlinedIcon
                sx={{
                  color: 'primary.main',
                  height: 56,
                  width: 56
                }}
              />
              <Typography
                color="textSecondary"
                variant="h6"
                sx={{ mt: 2 }}
              >
                No hay datos para mostrar en el panel de solicitudes de contacto
              </Typography>
            </CardContent>
          </Card>
        )
      }
    </>
  );
};

CallCenterAnalytics.propTypes = {
  oportunidades: PropTypes.array.isRequired
};